// 是不是pc端
export const isPc = isPcTemp

// 发送请求基地址
export const apiUrl: string = apiUrlTemp

// 图片视频基地址
export const baseUrl = apiUrl.replace('api/', '')

export const envFlag = process.env.NODE_ENV === 'development'
